import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/svg/appStore/AppStoreBadge.svg'
import _imports_1 from '@/assets/img/googlePlay/GooglePlayBadge.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "m-5 text-center" }, [
  /*#__PURE__*/_createTextVNode("\n      新しいバージョンがリリースされています\n      "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n      アプリをアップデートしてください\n    ")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "pb-3 text-center"
}
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  width: "145"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "pb-3 text-center"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  height: "80"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginHead = _resolveComponent("LoginHead")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_LoginHead),
    _createTextVNode(),
    _hoisted_1,
    _createTextVNode(),
    (!_ctx.isAndroid)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createElementVNode("a", {
            href: _ctx.externalLink.appStore
          }, _hoisted_5, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (!_ctx.isIos)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
          _createElementVNode("a", {
            href: _ctx.externalLink.googlePlay
          }, _hoisted_9, 8, _hoisted_7)
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}